import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');
var report = require('../generics/report_head');


pdfMake.fonts = {
	Roboto:{
		normal:'Roboto-Regular.ttf',
		bold:'Roboto-Medium.ttf',
		italics:'Roboto-Italic.ttf',
		bolditalics:'Roboto-MediumItalic.ttf'
	}
}

class Movements extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.generateExcel = this.generateExcel.bind(this);
		this.generatePDF = this.generatePDF.bind(this);

		this.state = {
			start_date: "",
			end_date:"",
			search_type:"date",
			start_folio: "",
			end_folio: "",	
			filename:"MOVIMIENTO DE SANGRE TOTAL Y SUS FRACCIONES",

			date_hour:"",
			medical:"",
			columns:[
				{title:'Prog.'},
				{title:'Fecha Ext'},
				{title:'Disponente'},
				{title:'Unidad'},
				{title:'Proced.'},
				{title:'Vol'},
				{title:'Hto/Hb', width:'100px'},
				{title:'Gpo-Rh', width:'40px'},
				{title:'Otros', width:'120px'},
				{title:'Caducidad', width:'140px'},
				{title:'Tipo de Disposición', width:'250px'}
			],

			components: [],
			serology_test: [],

			listado:[],

			name:"",
			service1:"",
			delegacion:"",
			address:"",
			tot:"",
			tot_own:"",
			work_sessions: [],
			work_sessions_id: 'all',
			format:'',
			total:0,
			total_own:0
		}

	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToImss){
			this.props.reload('hiddeToImss');
		}
	}

	componentDidMount(){	
		fetch(Config.default.apiGateway.URL+'reports_imss/hf_detail?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					name:response.hf_name,
					service1:response.service,
					delegacion:response.delegation,
					address:response.address
				})
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		});

		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
		   	headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			} else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					work_sessions: response
				});
			}
	   });
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'search_type'){
			this.setState({
				start_date:"",
				end_date 	: "",
				start_folio : "",
				end_folio   : "",
			});
		}

		if(e.target.name === 'format'){
			this.setState({listado:[]});
		}
	}

	generateExcel(e){
		e.preventDefault();

		this.props.waiting.handleShow('Generando Excel...');

		var obj = {
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			start_folio: this.state.start_folio,
			end_folio: this.state.end_folio,
			start_date: this.state.start_date,
			end_date:this.state.end_date,
			work_sessions_id: this.state.work_sessions_id,
			format:'entries'
		};

		if(this.state.format === 'egresos'){
			obj = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
				start_date: this.state.start_date,
				format:'exports'
			}
		}

		if(this.state.format === 'entries_summary'){
			obj = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
				start_date: this.state.start_date,
				format:'entries_summary'
			}
		}

		fetch(Config.default.apiGateway.URL+'reports_imss/generate_excel?report_name=movimientos_st_fracciones',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			this.props.waiting.handleClose();

			if(response !== undefined){
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})
	}

	generatePDF(e) {
		e.preventDefault();

		var obj = {
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			start_folio: this.state.start_folio,
			end_folio: this.state.end_folio,
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			work_sessions_id: this.state.work_sessions_id,
			format:'entries'
		};

		if(this.state.format === 'egresos'){
			obj = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
				start_date: this.state.start_date,
				format:'exports'
			}
		}

		if(this.state.format === 'entries_summary'){
			obj = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
				start_date: this.state.start_date,
				format:'entries_summary'
			}
		}

		this.props.waiting.handleShow('Generando PDF...');
		fetch(Config.default.apiGateway.URL+'reports_imss/generate_pdf?report_name=movimientos_st_fracciones',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var fileURL = URL.createObjectURL(response);
				window.open(fileURL);
			}
		})
	}

	searching(){
		if(this.isValidForm()){
			this.props.waiting.handleShow('Buscando...');

			this.setState({
				total: 0,
				total_own: 0
			})
			
			let object = {
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
				start_folio: this.state.start_folio,
				end_folio: this.state.end_folio,
				start_date: this.state.start_date,
				end_date: this.state.end_date,
				work_sessions_id: this.state.work_sessions_id,
				format:'entries'
			};

			if(this.state.format === 'egresos'){
				object = {
					health_facilities_id: sessionStorage.getItem('health_facilities_id'),
					start_date: this.state.start_date,
					format:'exports'
				}
			}

			if(this.state.format === 'entries_summary'){
				object = {
					health_facilities_id: sessionStorage.getItem('health_facilities_id'),
					start_date: this.state.start_date,
					format:'entries_summary'
				}
			}

			fetch(Config.default.apiGateway.URL+'reports_imss/movimientos_st_fracciones', {
				method : 'post',
				body:JSON.stringify(object),
				headers : new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			})
			.then(response => {
				
				if(response !== undefined && response !== null && response.error == null){
					var columns = [], list=[];

					if(this.state.format !== 'entries_summary'){
						if(this.state.format === 'ingresos'){
							columns = [
								{title:'Prog.', width:'60px'},
								{title:'Fecha Ext', width:'120px'},
								{title:'Disponente', width:'220px'},
								{title:'Unidad', width:'90px'},
								{title:'Proced.', width:'220px'},
								{title:'Vol', width:'90px'}
							];

							response.component_types.map((c)=>{
								columns.push({title: c.code_name, key: c.key, width: '40px'});
							});

							columns.push(
								{title:'Hto/Hb', width:'100px'},
								{title:'Gpo-Rh', width:'60px'}
							)

							response.serology_test.map((t)=>{
								columns.push({title: t.code_name, key: t.key, width: '70px'});
							});

							this.setState({
								components: response.component_types,
								serology_test: response.serology_test
							});

							columns.push(
								{title:'Otros', width:'120px'},
								{title:'Caducidad', width:'140px'},
								{title:'Tipo de Disposición', width:'250px'}
							)

							list = response.unit_list;
						}else{
							columns = [
								{title:'Adminsión', width:'90px'},
								{title:'Hemocomponente', width:'120px'},
								{title:'Unidad', width:'90px'},//muestra, vol, gpo, donador, fecha envio destino, usuario, no folio despacho
								{title:'Muestra', width:'90px'},
								{title:'Vol', width:'70px'},
								{title:'Gpo', width:'70px'},
								{title:'Donador', width:'200px'},
								{title:'Fecha Envio Destitno', width:'150px'},
								{title:'Usuario', width:'200px'},
								{title:'No. Folio Despacho', width:'120px'},
							];

							response.units.forEach((unit)=>{
								let obj = [
									moment(unit.donation_date).format('DD/MM/YYYY'),
									unit.component_name,
									unit.unit_number,
									unit.sample_number,
									unit.unit_volume,
									unit.unit_g_rh,
									unit.donor_names,
									moment(unit.exit_date).format('DD/MM/YYYY'),
									unit.user_names,
									unit.exit_filio
								];

								list.push(obj);
							})
						}
						this.setState({
							listado: list,
							columns:columns
						});
					}else{
						this.setState({
							listado: response.entries_list,
							total: response.total,
							total_own: response.total_own
						});
					}
				}
			})
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					IMSS ->
					{this.state.filename}
					</h5>
				</div>

				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_movimientos_st_fracciones"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format"
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="ingresos">Ingresos</option>
										<option value="egresos">Egresos</option>
										<option value="entries_summary">Resumen Ingresos</option>
									</select>
								</div>
								{this.state.format === 'ingresos' ?
									<>
										<div className="form-group">
											<span className="span-min">Tipo de Busqueda</span>
											<select className="form-control" name="search_type" id="search_type"
												value={this.state.search_type} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												<option value="date">Fecha</option>
												<option value="folio">Folio</option>
											</select>
										</div>
										{this.state.search_type === 'date' ?
											<div>
												<div className="form-group">
													<span className="span-min">Fecha Desde</span>
													<input type="date" className="form-control hour-input" name="start_date" id="start_date"
														value={this.state.start_date} onChange={this.handleChange} required />
												</div>
												<div className="form-group">
													<span className="span-min">Fecha Hasta</span>
													<input type="date" className="form-control hour-input" name="end_date" id="end_date"
														value={this.state.end_date} onChange={this.handleChange} required />
												</div>
											</div>
										: <div className="form-group">
											<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
												<span className="span-min">Folio Desde</span>
												<input type="text" className="form-control"  name="start_folio" id="start_folio"
													value={this.state.start_folio} onChange={this.handleChange} />
											</div>
											<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
												<span className="span-min">Folio Hasta</span>
												<input type="text" className="form-control" name="end_folio" id="end_folio"
													value={this.state.end_folio} onChange={this.handleChange} />
											</div>
										</div>
										}
										<div className="form-group">
											<span className="span-min">Sesión</span>
											<select className="form-control" name="work_sessions_id" id="work_sessions_id" 
												value={this.state.work_sessions_id} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												<option value="all">TODOS</option>
												{this.state.work_sessions.map((w, i)=>{
													return <option key={i} value={w.type}>
														{w.value}
													</option>
												})}
											</select>
										</div>
									</>	
								: this.state.format === 'egresos' || this.state.format === 'entries_summary' ?
									<div className="form-group">
										<span className="span-min">Fecha</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange} required />
									</div>
								: null
								}
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",fontSize: "20px"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generateExcel(e)} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generatePDF(e)}>PDF</button>
								</div>
								{this.state.format === 'entries_summary' ? 
									<div className='col-xs-12'>
										<div className='col-xs-12 form-group center'>
											<h2>Resumen Ingresos</h2>
										</div>

										<div className='col-xs-12' style={{display:'flex', marginTop:30, justifyContent:'center', alignItems:'center'}}>
											<div className='col-xs-12 col-md-10'>
												{this.state.listado.map((entry, i)=>
													<div className='col-xs-12' key={i}>
														<div className='col-xs-12 col-md-offset-2 col-md-4'>
															<label>{entry.component_name}</label>
														</div>
														<div className='col-xs-12 col-md-2'>
															<span>{entry.total}</span>
														</div>
													</div>
												)}

												<hr/>
												<div className='col-xs-12 '>
													<div className='col-xs-12 col-md-2 col-md-offset-1'>
														<label>PROPIAS </label>
													</div>
													<div className='col-xs-12 col-md-2'>
														<span>{this.state.total_own}</span>
													</div>
												</div>
												<div className='col-xs-12 form-group'>
													<div className='col-xs-12 col-md-2 col-md-offset-1'>
														<label>TOTAL </label>
													</div>
													<div className='col-xs-12 col-md-2'>
														<span>{this.state.total}</span>
													</div>
												</div>
											</div>
										</div>

									</div>
								:
									<div className="col-xs-12" id="table-to-pdf">
										<h5>FBS-4</h5>
										<h3 style={{textAlign:'center'}}>{this.state.format === 'ingresos' ? 'Ingresos' : this.state.format === 'egresos' ? 'Egresos' : ''}</h3>
										<div className="table-responsive">
											<table style={{fontSize:"11px"}} width="100%" className="table expenses-discards" id="table-to-xls">
												<thead>
													<tr>
														{this.state.columns.map((col, i)=>                                                            
															<th key={i} style={{width: col.width}}>
																{col.title}
															</th>
														)}
													</tr>
												</thead>
												<tbody>                                                
													{this.state.listado.map((l, i)=>
														this.state.format === 'ingresos' ?
															<tr key={i}>
																<td>{i + 1}</td>
																<td>{moment(l.date).format("DD/MM/YYYY")}</td>
																<td>{l.donor_name}</td>
																<td>{l.unit_number}</td>
																<td>{l.center_name}</td>
																<td>{l.volume}</td>
																
																{l.discard_reason === null ? 
																	this.state.components.map((c, j)=>                                                            
																		<td key={j}>{l.components.find(x => x.component_type == c.key) != null ? "X" : ""}</td>
																	)
																: <td colSpan={this.state.components.length} className='text-center'>{l.discard_reason}</td>}
																<td>{(l.hto ?? "") + "/" + (l.hb ?? "")}</td>
																<td>{l.g_rh}</td>														
																<Fragment>
																	{this.state.serology_test.map((t, j)=>                                                            
																		<td key={j} style={
																			l.test_results.find(x => x.key === t.key) != null ? 
																				l.test_results.find(x => x.key === t.key).code_name === 'POS' ||
																				l.test_results.find(x => x.key === t.key).code_name === 'RE' ||
																				l.test_results.find(x => x.key === t.key).code_name === 'ZG' ?
																					{background:'#ffb3b3'}
																				: {}
																			: {}
																		}>
																			{l.test_results.find(x => x.key === t.key) != null ? 
																			l.test_results.find(x => x.key === t.key).code_name : ""}
																		</td>
																	)}
																	<td>{l.other_test}</td>
																</Fragment>
																<td>
																{l.components.map((c, j)=>
																	<div key={j}>                                                     
																		{c.component_code + " " + c.component_number + " " + moment(c.expiration_date).format("DD/MM/YYYY")}
																	</div>
																)}
																</td>
																<td>{l.extraction_type + " - " + l.donation_type}</td>
															</tr>                             
														:
															<tr key={i}>
																{l.map((unit, j)=>
																	<td key={j}>{unit}</td>
																)}
															</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>
								}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (Movements);